var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"href":_vm.marianaTekLoginHref,"color":_vm.color,"plain":_vm.plain,"block":_vm.block,"x-large":"","dark":(_vm.plain) ? false : true,"depressed":""}},[_vm._v(" "+_vm._s(_vm.buttonText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }